import { useMemo } from "react";
import { toggleSort as sharedToggleSort, type SortConfig } from "@/shared/utils";
import type { CombinedTimesheetListItem } from "../types";

export type SortKey = "status" | "workDays" | "workHours" | "entries";

export type { SortConfig };

export function useTimesheetsSort(
  timesheets: CombinedTimesheetListItem[],
  sortConfig: SortConfig<SortKey> | null,
): CombinedTimesheetListItem[] {
  return useMemo(() => {
    if (!sortConfig) {
      return timesheets;
    }

    const { key, direction } = sortConfig;
    const statusOrder: Record<string, number> = { draft: 0, timesheet_approved: 1, calculated: 2, pending_payment: 3, paid: 4 };

    return [...timesheets].sort((a, b) => {
      let cmp = 0;

      if (key === "status") {
        const aStatus = statusOrder[a.combined_status] ?? -1;
        const bStatus = statusOrder[b.combined_status] ?? -1;
        cmp = aStatus - bStatus;
      } else if (key === "workDays") {
        cmp = (a.sum_work_days ?? 0) - (b.sum_work_days ?? 0);
      } else if (key === "workHours") {
        cmp = (a.sum_work_hours ?? 0) - (b.sum_work_hours ?? 0);
      } else if (key === "entries") {
        cmp = (a.entries_count ?? 0) - (b.entries_count ?? 0);
      }

      return direction === "asc" ? cmp : -cmp;
    });
  }, [timesheets, sortConfig]);
}

export function toggleSort(currentSort: SortConfig<SortKey> | null, newKey: SortKey): SortConfig<SortKey> {
  return sharedToggleSort(currentSort, newKey);
}
